import { Component, ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { RouterLink } from '@angular/router';


@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.css'
})
export class AboutUsComponent implements AfterViewInit, OnDestroy {
  @ViewChild('aboutSection') aboutSection!: ElementRef;

  isVisible = false;
  private observer: IntersectionObserver | null = null;

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible = true;
            // Desconectamos el observer para que la animación solo ocurra una vez
            if (this.observer) {
              this.observer.disconnect();
            }
          }
        });
      },
      {
        threshold: 0.2, // Se activa cuando el 20% de la sección es visible
        rootMargin: '0px 0px -50px 0px' // Un pequeño margen para que se active un poco antes de llegar al fondo
      }
    );

    if (this.aboutSection?.nativeElement) {
      this.observer.observe(this.aboutSection.nativeElement);
    }
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}